import { create } from 'zustand'

type UserConsentStore = {
    hasUserConsented: boolean;
    updateConsent: (value: boolean) => void;
};

const useUserConsentStore = create<UserConsentStore>((set) => ({
  hasUserConsented: false,
  updateConsent: (consent) => set({ hasUserConsented: consent }),
}));

export default useUserConsentStore;

